<template>
    <div class="page_content" style="padding: 0.3rem;">
        <h1 style="text-align: center;padding: 1rem 0;font-size: 0.5rem;">{{ appName }}隐私政策概要</h1>
        <div class="content" style="font-size: 0.24rem;">
            <p style="margin-bottom: 0.4rem;">
                {{ appName }}平台（APP）是一款由{{ company }}运营并提供按摩、保健生活服务的产品。我们非常注重保护用户（“您”）的个人信息及隐私，也感谢您对我们的信任。我们将通过本概要向您说明{{
                    appName }}会如何收集、存储、保护、使用及对外提供您的信息，并说明您享有的权利，本概要为<a href="./privacy">《{{ appName
    }}隐私政策》</a>的附件，如果您希望了解我们更详细的隐私政策请查看完整版的{{ appName }}隐私政策正文。</p>
            <h3 style="margin-bottom: 0.4rem;">一、我们如何收集和使用您的个人信息</h3>
            <h6>1，注册信息</h6>
            <p>在您注册成为{{ appName }}用户时，您需要至少提供手机号码以创建{{ appName
            }}账号，并完善相关的网络身份识别信息（头像、昵称及登录密码）；如果您仅需使用浏览、搜索功能，您无需注册成为我们的用户以及提供上述信息。
            </p>
            <h6>2，获取位置权限</h6>
            <p><span>使用目的：</span>经您授权，我们会收集和使用您的位置信息以便为您展示所在城市及周边的按摩保健服务（您不需要手动输入所在地理位置就可获得相关服务，估算商家与您之间的实际距离方便您进行消费决策，为您展示附近的服务品类和优惠信息）。
            </p>
            <P><span>信息说明：</span>位置信息来源包括IP地址、GPS以及能够提供相关信息的WLAN（Wi-Fi）接入点、蓝牙和基站。您使用服务中提供的信息中可能包含相应地理位置信息，您在账号资料中设置的地区信息或您上传的图片、视频中的地理标记信息。
            </P>
            <p>当您拒绝位置授权后仍可手动选择或输入位置信息，不会影响您使用基本的服务。但在个别场景下如（下单选择服务地址时）位置是必要的信息，如果您不同意授权位置信息则可能会影响您的正常使用。</p>
            <h6>3，获取相机权限</h6>
            <p>经您授权，我们会收集您的相机信息，通过使用拍照、录视频，扫码功能授权{{ appName }}访问您的相机，以便于您通过拍摄照片或录制视频方式发布内容，多用于登录账户、直接拍摄并上传图片用于发布信息或设置个人头像等。
            </p>
            <p>此项功能您可以在系统权限中关闭，一旦关闭您将可能无法实现扫码功能，或者无法通过拍摄图片、视频方式进行发布介绍视频或语音进行推广，但不会影响您享受{{ appName }}服务的基本功能。</p>
            <h6>4，获取相册权限</h6>
            <p>经您授权，我们会收集您的相册信息，通过主动上传图片、视频方式授权我们访问您的相册，以便于您通过上传照片或上传视频方式发布内容。我们会收集您选择上传发布的上述信息。此项功能您可以在系统权限中关闭，一旦关闭您将可能无法通过上传图片、视频方式进行更换头像、发布带图点评，但不会影响您享受{{
                appName }}平台服务的基本功能。
            </p>
            <h6>5，麦克风权限</h6>
            <p>经您授权，我们可能会收集您的语音信息以识别您的需求，以及对于平台内的特定主体有权上传语音介绍。我们承诺只在为您提供服务所必要的场中申请获取你设备的麦克风权限。在您同意开启麦克风权限后，只有您主动点击本客户端内的麦克风图标时，本客户端才会通过麦克风功能获取语音信息。
            </p>
            <p>您可以自行选择开启或关闭麦克风授权，一旦关闭您将可能无法使用如“录音“等相关功能，但不会影响您使用浏览、下单等基本服务。麦克风权限需要您的额外授权，您也可以在系统权限中自主控制，我们绝不会私自开启您的麦克风权限，更不会非法利用非法手段进行相关信息的收集和使用，请您放心。
            </p>
            <h6>6，日历授权</h6>
            <p>经您授权，使用添加日历功能记录{{ appName }}相关服务的日程，我们会收集上述信息用于向您展示或定时提醒。</p>
            <p>此项功能您可以在系统权限中关闭，一旦关闭您将可能无法享受日历记录或提醒功能，但不会影响您享受{{ appName }}服务的基本功能。</p>
            <h6>7，设备信息</h6>
            <p>在您访问或使用我们服务的过程中，我们会收集您的设备信息，以便识别您的手机设备、避免其他设备的异常登录、留存必要的日志信息，从而保障您的账号安全、交易安全和系统运行安全。此外，如您未登录账号，我们使用您的设备信息以便为您推送对应的信息展示。
            </p>
            <p>您理解并同意，在上述情形下，我们可能需要您在您的设备中开启您的摄像头（相机）、相册（图片库）、麦克风（语音）以及日历访问权限，以实现这些权限所涉及信息的收集和使用。您可在您的设备中逐项查看上述权限的状态，并可自行决定这些权限的开启或关闭。当您开启任一权限即代表您授权我们收集和使用该项信息来实现对应目标。您一旦关闭任一权限即代表您取消了授权，我们将不再继续收集和使用该项个人信息，也无法为您实现该授权所对应目标。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息的收集、处理与使用。
            </p>
            <h3>二、我们如何共享您的信息</h3>
            <p>请您知悉，我们为您所提供的产品/服务大多是无法单独完成的，因此我们可能会与我们的关联公司以及其他合作商等第三方共享或委托其处理您的部分个人信息。目前，除再次获得您明确同意或授权外，此类共享或委托处理涉及的主要情形包括：根据行政、司法等有权机关的要求提供必要信息；为提供账号一致性服务与关联公司共享必要信息；为提供如配送、第三方支付等服务与有关合作商、第三方商家、支付机构等共享有关的必要信息等。
            </p>
            <p>我们会与其签署严格的信息保护和保密协定，要求他们遵守协议并采取相关的安全措施来保护您的个人信息。</p>
            <p>对于我们使用的第三方软件工具开发包（“SDK”），以及与第三方共享的个人信息，您可以点击<a href="./privacy">《{{ appName }}隐私政策》</a>正文查看详细第三方共享个人信息清单。
            </p>
            <h3>三、您如何管理您的信息</h3>
            <p>您有权管理您的个人信息，包括查询、更正和删除您的账号信息、地址信息、搜索记录、评论信息，改变您授权同意的范围或撤回授权，以及注销您的账号。您可以通过我们的App中提供的功能设置进行上述操作。</p>
            <p>如果您无法通过上述方式进行管理，您可以通过我们以下提供的联系方式联系我们，我们将在15天内回复您的要求。</p>
            <h3>四、未成年人的个人信息保护</h3>
            <p>{{ appName
            }}非常重视对未成年人个人信息的保护。我们的网站和服务主要面向成人。如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
            </p>
            <p>如您为未成年人的父母或监护人，当您对您所监护的未成年人的信息处理存在疑问时，请通过下文中的联系方式联系我们。</p>
            <h3>八、如何联系我们</h3>
            <p>您可以通过以下方式与我们联系，我们将在15 天内答复您的请求；</p>
            <p>1、您可以通过{{ appName }}网站（{{ link }}）/App上提供的在线联系方式/客服系统与我们联系；</p>
            <p>2、您可以联系{{ appName }}的客服电话进行反馈（联系方式：400-862-0602）。</p>
            <p>3、我们还设立了专门的个人信息保护团队，如果您有任何个人信息的疑问、意见、建议或投诉举报，您可以通过 wzh@angemo.com
                联系我们，或者寄信到如下地址：深圳市罗湖区东晓街道绿景社区布吉路1028号中设广场B楼3层306A 法务部隐私保护中心（收），邮编：518000。</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "privacyAbstract",
    data() {
        return {
            appName: '',
            company: '',
            link: '',
            type: 0
        };
    },
    mounted() {
        this.type = this.$route.params.type || 0;

        if (this.type == 0) {
            this.appName = '按个摩'
            this.company = '深圳凸凸网络科技有限公司'
            this.link = 'https://www.angemo.com/'
        } else if (this.type == 1) {
            this.appName = '按个摩'
            this.company = '深圳市凹凸科技有限公司'
            this.link = 'http://www.twototwo.com/'
        }else if (this.type == 2) {
            this.appName = '按个摩上门按摩'
            this.company = '深圳凸凸网络科技有限公司'
            this.link = 'https://www.angemo.com/'
        }
    },
};
</script>
<style >
h6 {
    font-size: 0.3rem;
    font-weight: bold;
}

h3 {
    font-size: 0.4rem;
    font-weight: bold;
}

span {
    font-weight: bold;
}

h3,
h6,
p {
    margin-bottom: 0.2rem;
}
</style>